import { Flex, Text } from "@chakra-ui/react";
import * as React from "react";

import { useChoiceByDate } from "@/hooks/useChoiceByDate";

import { disasterTypes } from "../constants";

type SimulatedDisasterProps = {
  auditDate: Date | undefined;
};

export const SimulatedDisaster = React.memo(
  ({ auditDate }: SimulatedDisasterProps) => {
    const shiftChoice = useChoiceByDate(auditDate, disasterTypes.length);

    return (
      <Flex>
        <Text as="b">Simulated Disaster:</Text>
        <Text marginLeft="5px">{disasterTypes[shiftChoice]}</Text>
      </Flex>
    );
  },
);
